/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Arrow Right"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M16.05 17.739a1.06 1.06 0 0 1-1.414-.018.874.874 0 0 1 .02-1.306l3.884-3.492H3c-.552 0-1-.413-1-.923s.448-.923 1-.923h15.54l-3.885-3.492a.874.874 0 0 1-.02-1.306 1.06 1.06 0 0 1 1.415-.018l5.647 5.077A.9.9 0 0 1 22 12a.9.9 0 0 1-.303.662z"
      className="SVG"
    />
  </svg>
);

export const ArrowRightIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'arrow-right-icon'}
      icon={ArrowRight}
      {...props}
      size={size}
    />
  );
};
